import { memo } from 'react'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
  ChartOptions,
} from 'chart.js'
import { Bar, Line } from 'react-chartjs-2'
import { IChatDealerUsageReport } from '../models'
import { buildDailyActiveChart, buildTopDealersChart } from '../viewModel'
import styles from './ChatbotAnalytics.module.scss'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Tooltip, Legend)

const lineOptions: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  plugins: { legend: { position: 'bottom' } },
  scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
}

/** Yatay bar: bayi ünvanları uzun, dikey eksende okunaklı olur. */
const horizontalBarOptions: ChartOptions<'bar'> = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: { x: { beginAtZero: true, ticks: { precision: 0 } } },
}

interface DealerUsageChartsProps {
  data: IChatDealerUsageReport
}

function DealerUsageCharts({ data }: DealerUsageChartsProps) {
  return (
    <div className={styles.chartGrid}>
      {data.DailyActiveDealers.length > 0 ? (
        <section className={`${styles.panel} ${styles.trendPanel}`} aria-labelledby='usage-daily-active-title'>
          <div className={styles.panelHeader}>
            <div>
              <span className={styles.eyebrow}>Benimseme</span>
              <h2 id='usage-daily-active-title'>Günlük Aktif Bayi / Kullanıcı</h2>
            </div>
          </div>
          <div className={styles.chartCanvas} role='img' aria-label='Günlük aktif bayi ve kullanıcı grafiği'>
            <Line data={buildDailyActiveChart(data)} options={lineOptions} />
          </div>
        </section>
      ) : null}

      {data.TopDealersByTurns.length > 0 ? (
        <section className={styles.panel} aria-labelledby='usage-top-dealers-title'>
          <div className={styles.panelHeader}>
            <div>
              <span className={styles.eyebrow}>Yoğunluk</span>
              <h2 id='usage-top-dealers-title'>En Çok Kullanan Bayiler</h2>
            </div>
          </div>
          <div className={styles.chartCanvas} role='img' aria-label='En çok kullanan bayiler grafiği'>
            <Bar data={buildTopDealersChart(data)} options={horizontalBarOptions} />
          </div>
        </section>
      ) : null}
    </div>
  )
}

export default memo(DealerUsageCharts)
